import { CheckboxField } from '@cian/components';
import * as React from 'react';
import { FromToControl } from '../../../../../../../common/components/from_to_control';
import { InlineParam } from '../../../markup';

export interface IFloorProps {
  isNotFirst?: boolean;
  isNotLast?: boolean;
  isSemibasement: boolean;
  maxFloor: number | undefined;
  minFloor: number | undefined;

  onIsNotFirstChange(value: boolean | undefined): void;
  onIsNotLastChange(value: boolean | undefined): void;
  onIsSemibasementChange(value: boolean | undefined): void;
  onMaxFloorChange(value: number | undefined): void;
  onMinFloorChange(value: number | undefined): void;
}

export const Floor: React.StatelessComponent<IFloorProps> = props => {
  const {
    minFloor,
    maxFloor,
    onMinFloorChange,
    onMaxFloorChange,
    onIsNotFirstChange,
    onIsNotLastChange,
    isNotFirst,
    isNotLast,
  } = props;

  return (
    <>
      <InlineParam>
        <FromToControl
          rangeGroupStyle={{ width: 120 }}
          from={{
            value: minFloor,
            placeholder: 'от',
            onValueChange: onMinFloorChange,
          }}
          to={{
            value: maxFloor,
            placeholder: 'до',
            onValueChange: onMaxFloorChange,
          }}
        />
      </InlineParam>
      <InlineParam>
        <CheckboxField
          onValueChange={value => onIsNotFirstChange(value ? !value : undefined)}
          value={isNotFirst === false}
          label="Не первый"
        />
      </InlineParam>
      <InlineParam>
        <CheckboxField
          onValueChange={value => onIsNotLastChange(value ? value : undefined)}
          value={isNotLast === true}
          label="Не последний"
        />
      </InlineParam>
      <InlineParam>
        <CheckboxField
          onValueChange={value => onIsNotLastChange(value ? !value : undefined)}
          value={isNotLast === false}
          label="Только последний"
        />
      </InlineParam>
    </>
  );
};
